module.exports = __webpack_public_path__ + "static/smartMirrorCov-c04c675d460f05361476fc2770842669.png";